"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MuiSwitch = void 0;
var colors_1 = require("../colors");
exports.MuiSwitch = {
    defaultProps: {
        color: 'primary',
    },
    styleOverrides: {
        root: {
            width: '36px',
            height: '24px',
            padding: '0',
            margin: '4px',
        },
        colorPrimary: {
            '&.Mui-checked': {
                color: '#0060E0',
                '& + .MuiSwitch-track': {
                    backgroundColor: '#0060E0',
                },
            },
            '&.Mui-disabled + .MuiSwitch-track': {
                backgroundColor: colors_1.tannerGray['500'],
                opacity: 0.3,
            },
            '&.Mui-disabled.Mui-checked + .MuiSwitch-track': {
                opacity: 0.3,
                backgroundColor: colors_1.tannerBlue['500'],
            },
        },
        switchBase: {
            color: colors_1.tannerGray['200'],
            padding: 2,
            '&.Mui-disabled': {
                color: '#F8F8F8',
            },
            '&.Mui-disabled div': {
                'box-shadow': 'none',
                background: colors_1.tannerGray[100],
            },
            '&.Mui-disabled.Mui-checked div': {
                'box-shadow': 'none',
                background: colors_1.tannerWhite,
            },
            '&.Mui-disabled.Mui-checked': {
                opacity: 1,
                color: '#B2D1F9',
            },
            '&:hover': {
                backgroundColor: 'transparent',
                transform: 'translateX(2px)',
            },
            '&:hover.Mui-checked': {
                transform: 'translateX(8px)',
            },
            '&.Mui-checked': {
                transform: 'translateX(10px)',
                '& + .MuiSwitch-track': {
                    opacity: 1,
                },
            },
            '&.Mui-checked svg': {
                color: colors_1.tannerBlue[500],
            },
            '&.Mui-disabled.Mui-checked svg': {
                opacity: 0.3,
            },
        },
        track: {
            borderRadius: 28 / 2,
            opacity: 1,
            transition: 'background-color 200ms',
            backgroundColor: colors_1.tannerGray['500'],
        },
    },
};
//# sourceMappingURL=MuiSwitch.js.map